import * as React from 'react'
import {FC} from 'react'
import {observer} from 'mobx-react'
import {WidgetApi} from '../../lib/WidgetApi'
import {useStores} from '../../lib/MobXProvider'

///////////////////////////////////////////////////////////////////////////////

export type DynamicContentProps = {
  text_html: string
  [key: string]: any
}

///////////////////////////////////////////////////////////////////////////////

export const DynamicContent: FC<DynamicContentProps> = observer((props) => {
  const {api} = useStores<{api: WidgetApi}>()
  const {text_html} = props
  const textHTML = text_html ? api.trans(text_html, {defaultValue: null}) : null

  if (!textHTML) {
    return null
  }

  return (
    <div
      className="widget-custom-content"
      dangerouslySetInnerHTML={{__html: textHTML}}
    />
  )
})
